module.exports = __webpack_public_path__ + "static/media/dashboard-b.c35eac07.svg";